import { Injectable } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ButtonLoader } from '../../utils';
import { FormsUtilsService } from '../forms';
import { MessageService } from '../message';
import { BaseReportFilter } from './base-report-filter.interface';
import { ReportHttpService } from './report-http-service';

@Injectable({
    providedIn: 'root'
})
export class BaseReportService {

    constructor(private formsUtilsService: FormsUtilsService,
                private messageService: MessageService) { }

    /** Abre o PDF do relatório em uma nova aba */
    open(pdf: Blob, print = false) {
        const fileURL = URL.createObjectURL(pdf);
        const w = window.open(fileURL, '_blank');

        if (print) {
            // w.print();
            w.onload = () => {
                w.print();
            };
        }
    }

    /** Abre o erro ao imprimir o relatório em formato HTML */
    openError(error: any) {
        const blob = new Blob(['\ufeff', error], {type: 'text/html;'});
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL, '_blank');
    }

    /**
     * Exibe mensagem ao usuário que o formulário do filtro do relatório está invalido
     */
    private showMsgFormFilterInvalid() {
        this.messageService.info('Para imprimir é preciso informar corretamente todos os campos destacados em vermelho', 'Informação');
    }

    /** Impressão padrão dos relatórios do sistema
     *
     * @param filter Filtro do relatório
     * @param form Formulário do filtro do relatório
     * @param serviceHttp Service Http da do relatório utilizado para realizar enviar o request ao servidor
     * @param btnPrint Botão de impressão do relatório (utilizado para apresentar mensagem de 'loading')
     */
    print<T extends BaseReportFilter>(filter: T, form: NgForm, serviceHttp: ReportHttpService<T>, btnPrint: ButtonLoader): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.formsUtilsService.makeAllFieldsDirty(form);

            if (form.valid) {
                btnPrint?.loading('Imprimindo');

                serviceHttp.print(filter)
                    .subscribe(
                        pdf => {
                            btnPrint?.reset();
                            this.open(pdf);
                            resolve(pdf);
                        },
                        error => {
                            btnPrint?.reset();
                            this.openError(error);
                            reject(error);
                        }
                    );
            } else {
                this.showMsgFormFilterInvalid();
            }
        });
    }
}
